/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ModalType =
  | 'logout'
  | 'createCustomer'
  | 'splitTable'
  | 'submitPayment'
  | 'addPayment'
  | 'printInvoice'
  | 'choosePrinter'
  | 'defaultPrinter'
  | 'KOTPrinter';

type ModalState = Record<ModalType, boolean>;

interface PayloadType {
  type: ModalType;
}
const initialState: ModalState = {
  logout: false,
  createCustomer: false,
  splitTable: false,
  submitPayment: false,
  addPayment: false,
  printInvoice: false,
  choosePrinter: false,
  defaultPrinter: false,
  KOTPrinter: false,
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (
      state: Record<ModalType, boolean>,
      { payload }: PayloadAction<PayloadType>,
    ) => {
      state[payload.type] = true;
    },
    closeModal: (
      state: Record<ModalType, boolean>,
      { payload }: PayloadAction<PayloadType>,
    ) => {
      state[payload.type] = false;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
